import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import { Link } from "react-router-dom";
import { Outlet } from 'react-router-dom';

export default function ButtonAppBar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
			<Link to={"/"}>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
			  sx={{ mr: 2, color: '#fff' }}
          >
            <HomeIcon />
          </IconButton>
			</Link>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Protostructure
          </Typography>
			<Link to={"/login"}>
				<Button sx={{color: '#fff'}}>Login</Button>
			</Link>
        </Toolbar>
      </AppBar>

		<Outlet />
    </Box>
  );
}
